var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlexible(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "90px",
    height: "90px",
    viewBox: "0 0 90 90",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 25@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "30 0 55.9807621 15 55.9807621 45 30 60 4.01923789 45 4.01923789 15"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-32.5%",
    y: "-32.5%",
    width: "185.0%",
    height: "185.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 6,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.622987115   0 0 0 0 0.642494553   0 0 0 0 0.759539176  0 0 0 0.4 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Website-Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Barlow-Marshall---Home-V2",
    transform: "translate(-951.000000, -2131.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-25",
    transform: "translate(960.000000, 2140.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Polygon-Copy-17"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "noun-flexibility-1116121",
    transform: "translate(17.000000, 23.000000)",
    fill: "#2283FB",
    fillRule: "nonzero",
    stroke: "#2283FB",
    strokeWidth: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7952373,5.8193454 L14.4015416,6.52619451 L9.41331057,6.52619451 C9.19281167,6.52619451 9,6.75121006 9,7.00804529 C9,7.26511001 9.19300852,7.48989606 9.41331057,7.48989606 L14.4015416,7.48989606 L13.7952373,8.19674517 C13.6299111,8.38948777 13.6299111,8.67859594 13.7952373,8.87157952 C13.8779004,8.96795082 13.9882458,9 14.0983993,9 C14.2085528,9 14.3188982,8.96795139 14.4015613,8.87157952 L16,7.00806824 L14.4015613,5.14455695 C14.2362351,4.95181435 13.9882507,4.95181435 13.8227179,5.14455695 C13.6573917,5.33752332 13.6299013,5.65868067 13.795228,5.8193913 L13.7952373,5.8193454 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4119761,5.38133935 C24.250513,5.21392572 24.008323,5.21392572 23.846658,5.38133935 C23.6851949,5.54875298 23.6851949,5.79986844 23.846658,5.96749137 L24.4387953,6.58145098 L22.2855207,6.58145098 C21.0205,6.58145098 19.9976212,5.52092546 19.9976212,4.20923464 C19.9976212,2.45102775 18.6249873,1 16.9024541,1 L16.1488248,1 C15.9334781,1 15.7451717,1.19544547 15.7451717,1.41852909 C15.7451717,1.64181204 15.9336703,1.83705818 16.1488248,1.83705818 L16.9024541,1.83705818 C18.1674747,1.83705818 19.1903535,2.8975837 19.1903535,4.20927451 C19.1903535,5.15807134 19.5940066,5.99533882 20.2131842,6.58149085 L19.6210469,6.58149085 C17.9253329,6.58149085 16.5258798,8.00471101 16.5258798,9.79072549 C16.5258798,11.1023665 15.503049,12.1629418 14.2379803,12.1629418 L13.4036531,12.1629418 C13.1883064,12.1629418 13,12.3583873 13,12.5814709 C13,12.8047539 13.1884986,13 13.4036531,13 L14.2379803,13 C15.9336944,13 17.3331475,11.5767798 17.3331475,9.79076536 C17.3331475,8.47912438 18.3559782,7.41854902 19.6210469,7.41854902 L24.4388915,7.41854902 L23.8467542,8.03250863 C23.685291,8.19992226 23.685291,8.45103772 23.8467542,8.61866065 C23.9274857,8.70236747 24.0352528,8.73020495 24.1428324,8.73020495 C24.250412,8.73020495 24.3581791,8.70236796 24.4389107,8.61866065 L26,7.00003987 L24.4119761,5.38133935 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.39896299,8 L5.88087642,8 C7.67626078,8 9.15797066,6.52972441 9.15797066,4.68471126 C9.15797066,3.32974192 10.2409211,2.23413183 11.5803477,2.23413183 L13.347133,2.23413183 L12.7201911,2.8683728 C12.5492375,3.04131672 12.5492375,3.30072745 12.7201911,3.47388759 C12.8056679,3.56035955 12.9197693,3.58911662 13.0336722,3.58911662 C13.1475751,3.58911662 13.2616765,3.56036007 13.3471533,3.47388759 L15,1.80179777 L13.3471533,0.129707941 C13.1761997,-0.0432359803 12.9197744,-0.0432359803 12.7486071,0.129707941 C12.5776534,0.302651862 12.5776534,0.562062596 12.7486071,0.735222736 L13.3755489,1.3694637 L11.6087637,1.3694637 C9.81337932,1.3694637 8.33166945,2.8396981 8.33166945,4.68471126 C8.33166945,6.0396806 7.24871901,7.13529069 5.90929236,7.13529069 L4.42737893,7.13529069 C4.19937463,7.13529069 4,7.33719245 4,7.56764535 C4,7.79809824 4.17095361,8 4.39895281,8 L4.39896299,8 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.82327333,10.5342777 C9.66003486,10.7075351 9.66003486,10.9674162 9.82327333,11.1408903 L10.4219213,11.7762813 L5.93196454,11.7762813 C4.65303485,11.7762813 3.6189094,10.6787363 3.6189094,9.32125858 C3.6189094,7.50167841 2.23118322,6 0.489710536,6 L0.408091304,6 C0.190376848,6 0,6.20226784 0,6.43313858 C0,6.66421562 0.190571214,6.86627715 0.408091304,6.86627715 L0.489710536,6.86627715 C1.76864023,6.86627715 2.80276567,7.96382217 2.80276567,9.32129984 C2.80276567,11.14088 4.19049185,12.6425584 5.93196454,12.6425584 L10.4217269,12.6425584 L9.82307896,13.2779494 C9.6598405,13.4512069 9.6598405,13.7110879 9.82307896,13.8845621 C9.9046982,13.9711908 10.0136502,14 10.1224127,14 C10.2311751,14 10.3401271,13.9711913 10.4217463,13.8845621 L12,12.2094405 L10.3945837,10.5343189 C10.2313452,10.3610614 9.98649236,10.3610614 9.82324417,10.5343189 L9.82327333,10.5342777 Z",
    id: "Path"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlexible);
export default __webpack_public_path__ + "static/media/flexible.17bf2a7f35a45c4ae890bdaa8e04e6a2.svg";
export { ForwardRef as ReactComponent };